import { RegionInfoFilter } from "../../models/region";
import { useGetList } from "react-admin";
import { Box, Typography } from "@mui/material";
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Legend, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { useMapAttributeName, useMapAttributeType } from "../../hooks/use-map-attribute";
import { useDataType } from "../../hooks/use-data-type";

type RegionAttributeData = {
  id: number;
  value: number;
  count: number;
  month: string;
}


export const RegionMapAttributeChart = ({ filter }: { filter: RegionInfoFilter }) => {

  const [attributeName] = useMapAttributeName();
  const [_, getDataTypeString, getDataTypeUnit] = useDataType();

  const { data: attributeData, isLoading: isLoadingAttribute } = useGetList<RegionAttributeData>('region/attribute', { filter });

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <Box >
          <Typography>{`${payload[0].payload.month}: ${getDataTypeString(payload[0].payload.value)}`}</Typography>
        </Box>
      );
    }

    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={200}>
      <AreaChart
        width={500}
        height={400}
        data={attributeData}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis mirror unit={getDataTypeUnit()} />
        <Tooltip content={<CustomTooltip payload={attributeData} />} />
        <Area name={attributeName} type="monotone" dataKey="value" />
        <Legend align='right' verticalAlign='top' />
      </AreaChart>
    </ResponsiveContainer>
  )
};

